import * as actionTypes from '../consts/actionTypes';

const initialState = {
    emergencyNumbers: [],
    msgError: ''
};

export default function emergencyReducer(state = initialState, action) {
    const DEFAULT = { ...state };
    const ACTIONS = {
        [actionTypes.SUCCESS_GET_EMERGENCY_NUMBERS]: responseToReturn(),
        [actionTypes.FAILURE_GET_EMERGENCY_NUMBERS]: responseToReturn()
    };
    function responseToReturn() {
        let res = { ...state };
        if (action.response) {
            res = { ...state, emergencyNumbers: action.response.data, msgError: action.message };
        }
        if (action.message) {
            res = { ...state, msgError: action.message };
        }
        return res;
    }

    let receiveAction = DEFAULT;

    if (ACTIONS[action.type] !== undefined) {
        receiveAction = ACTIONS[action.type];
    }

    return receiveAction;
}